import moment from 'moment/moment';

export default {
  date(date, format = 'D/MM/YY', nullVal = 'N/A') {
    return date ? moment(date).format(format) : nullVal;
  },
  time(time, format = 'hh:mma', nullVal = 'N/A') {
    return time ? moment(time, 'HH:mm:ss').format(format) : nullVal;
  },
  dateTime(date, format = 'D/MM/YY, hh:mma', nullVal = 'N/A') {
    return date ? moment(date).format(format) : nullVal;
  },
  timeAgo(date) {
    return moment(date).fromNow();
  },
  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  },
  floatingPointPlaces(value, places) {
    let refinedValue = value?.toString();
    if (typeof value === 'number') {
      let splittedValue = value.toString().split('.');
      if (splittedValue.length == 2 && splittedValue[1].length > places) {
        splittedValue[1] = splittedValue[1].slice(0, places);
        refinedValue = splittedValue.join('.');
      }
    }
    return refinedValue;
  },
  onlyLetterString(string) {
    // It's never guaranteed that the return value would be unique, it will remove unaccepted characters
    if (string) {
      return string.replace(/[^a-zA-Z]/g, '');
    } else {
      return '';
    }
  },
  onlyAlphanumericString(string) {
    // It's never guaranteed that the return value would be unique, it will remove unaccepted characters
    if (string) {
      return string.replace(/[^a-zA-Z0-9]/g, '');
    } else {
      return '';
    }
  }
};
